import React, { Component } from "react";
import {
  Row,
  Col,
  Input,
  Table,
  Button,
  Form,
  Select,
  Avatar,
  Icon,
  Typography,
  Modal,
} from "antd";
import FromInput from "../../../../components/user/from/Input";
import { checkLinkURL } from "../../../../utils/auth";
import { getExternalsType } from "worker-loader/dist/utils";

const { Option } = Select;
const { Text, Title } = Typography;
class SecProfileInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
    dataTalbeUploads: [
      // {
      //    documentType: null,
      //    description: null,
      //    file:[]
      // },
      // {
      //    documentType: null,
      //    description: 12312313,
      //    file:[]
      // },
    ],
    columnsAttachment: [
      {
        title: "ประเภทเอกสาร",
        dataIndex: "documentType",
        vertical: "top",
        width: "30%",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {record.attachFileId && (
                <>
                  <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
                    {this.props.propFormInput.getFieldDecorator(
                      `attachFile[${index}].attachFileId`,
                      {
                        initialValue: record.attachFileId
                          ? record.attachFileId
                          : null,
                      }
                    )(<Input />)}
                  </Form.Item>
                  <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
                    {this.props.propFormInput.getFieldDecorator(
                      `attachFile[${index}].filePath`,
                      {
                        initialValue: record.filePath ? record.filePath : null,
                      }
                    )(<Input />)}
                  </Form.Item>
                </>
              )}
              <Form.Item label={""} style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  `attachFile[${index}].documentType`,
                  {
                    initialValue: record.documentType
                      ? record.documentType
                      : null,
                    rules: [
                      {
                        required: true,
                        message: "กรุณาระบุประเภทเอกสาร",
                      },
                    ],
                  }
                )(
                  <Select
                    style={{ width: "100%" }}
                    disabled={this.props.isViewOnly || record.attachFileId}
                    showSearch
                    placeholder="กรุณาเลือกประเภทเอกสาร"
                    optionFilterProp="children"
                    onChange={(value) =>
                      this.onChangeValueForm(index, value, "documentType")
                    }
                  >
                    {this.props.dropDownTypeDoc &&
                      this.props.dropDownTypeDoc.map((values, keys) => (
                        <Option value={values.value}>{values.label}</Option>
                      ))}
                  </Select>
                )}
              </Form.Item>{" "}
            </>
          );
        },
      },
      {
        title: "รายละเอียดเพิ่มเติม",
        dataIndex: "description",
        align: "center",
        vertical: "top",
        width: "30%",
        render: (item, record, index) => {
          return (
            <>
              <Form.Item label={""} style={{ marginBottom: "0px" }}>
                {this.props.propFormInput.getFieldDecorator(
                  `attachFile[${index}].description`,
                  {
                    initialValue: record.description ? record.description : "",
                  }
                )(
                  <Input
                    // defaultValue={item}
                    // style={{ width: "150px" }}
                    disabled={this.props.isViewOnly || record.attachFileId}
                    onBlur={(e) =>
                      this.onChangeValueForm(index, e, "description")
                    }
                  />
                )}
              </Form.Item>
            </>
          );
        },
      },
      {
        title: "เอกสารแนบ",
        dataIndex: "file",
        width: "100px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return <>{this.inputFormUploads(index, record)}</>;
        },
      },
      {
        title: "การจัดการ",
        dataIndex: "5",
        width: "60px",
        align: "center",
        render: (item, record, index) => {
          return this.showDetailBtnInput(record, index);
          //  return this.showDetailBtnInput(
          //    record,
          //    index,
          //    record.studyLearnRecordId ? record.studyLearnRecordId : null
          //  );
        },
      },
    ],
    dataTalbeLength: 1,
  };

  onChangeValueForm = async (arrayId, values, name) => {
    const { dataTalbeUploads } = this.state;
    let dataSourceitems = [...this.state.dataTalbeUploads];
    let item = { ...dataSourceitems[arrayId] };
    console.log("valxxxues", name);
    if (name == "documentType") {
      item.documentType = values;
    } else if (name == "description") {
      item.description = values.target.value;
    }

    dataSourceitems[arrayId] = item;

    await this.setState(
      {
        dataTalbeUploads: dataSourceitems,
      },
      async () => {
        // await this.setSummary()
        // this.cllBackSetValueContactNumber()
      }
    );
  };

  onClickToNewTab = (typeFile) => {
    const { linkNewTab } = this.state;
    if (typeFile !== "application/pdf") {
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          linkNewTab +
          '" style="max-width:100%;height:100%"/></div>'
      );
    } else {
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          linkNewTab +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  modalShowFileCreate = async (dataFile, title) => {
    const { linkNewTab } = this.state;
    console.log("dataFile", dataFile);
    var url = URL.createObjectURL(dataFile);
    const reader = new FileReader();
    if (dataFile.type !== "application/pdf") {
      reader.readAsDataURL(dataFile);
      reader.onloadend = async (e) => {
        var dataURL = reader.result;
        await this.setState({
          linkNewTab: dataURL,
        });

        Modal.info({
          className: "modalFickIcons pt-4",
          title: "ไฟล์อัปโหลดเอกสารแนบ",
          width: "800px",
          content: (
            <div>
              <hr></hr>
              <div className="pt-4">
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col span={8} style={{ display: "block" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        padding: "10px 55px",
                      }}
                      align="center"
                      className="block-show-image-modal"
                    >
                      <img src={dataURL} className="zoom-in" />
                      <a
                        onClick={() => this.onClickToNewTab(dataFile.type)}
                        className="icons-delect-images"
                      >
                        <Icon type="eye" style={{ color: "#fff" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ),
          okText: "ปิด",
          onOk() {},
        });
      };
    } else {
      reader.readAsDataURL(dataFile);
      reader.onloadend = async (e) => {
        var dataURL = reader.result;
        // var output = document.getElementById('show-pdf-popup');
        // output.href = dataURL;
        await this.setState({
          linkNewTab: dataURL,
        });

        Modal.info({
          className: "modalFickIcons pt-4",
          title: "ไฟล์อัปโหลดเอกสารแนบ",
          width: "800px",
          content: (
            <div>
              <hr></hr>
              <div className="pt-4">
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col span={8} style={{ display: "block" }}>
                    <div
                      style={{ width: "100%", height: "200px" }}
                      align="center"
                      className="block-show-image-modal"
                    >
                      <a
                        onClick={() => this.onClickToNewTab(dataFile.type)}
                        className="color-white"
                      >
                        <Icon type="file-pdf" />
                        <br></br>
                        ดูไฟล์ PDF
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ),
          okText: "ปิด",
          onOk() {},
        });
      };
    }
  };

  modalShowFileDataBase = async (dataFile, title) => {
    if (dataFile.fileType !== "application/pdf") {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })
      console.log("hi no pdf");
      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      src={checkLinkURL() + dataFile.filePath}
                      style={{ height: "100%" }}
                    />
                    <a
                      onClick={() => this.onClickToNewTab2(dataFile)}
                      className="icons-show-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    } else {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      console.log("hi pdf");
      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <iframe
                      style={{ opacity: "0", height: "0" }}
                      style={{ display: "none" }}
                    ></iframe>
                    <a
                      onClick={() => this.onClickToNewTab2(dataFile)}
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                    <br></br>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
  };

  onClickToNewTab2 = (typeFile, arrayId) => {
    const { detailForm } = this.props;
    //const { linkNewTab} = this.state
    console.log("onClickToNewTab2");
    console.log("onClickToNewTab2 typeFile", typeFile);

    if (typeFile.fileType !== "application/pdf") {
      console.log("onClickToNewTab2 non pdf");
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          checkLinkURL() +
          typeFile.filePath +
          '" style="height:100%"/></div>'
      );
    } else {
      console.log("onClickToNewTab2 pdf");
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          checkLinkURL() +
          typeFile.filePath +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  inputFormUploads = (arrayId, item) => {
    const { isViewOnly, propFormInput } = this.props;
    const { dataTalbeUploads } = this.state;

    console.log("item.file", item.file);
    return (
      <>
        {
          !item.attachFileId && (
            <>
            <label
              for={`attachFile[${arrayId}].file`}
              class="custom-file-upload"
            >
              <p
                className="py-2 px-4 mb-0"
                align={"center"}
                style={{ backgroundColor: "#8d0e14", color: "#fff" }}
              >
                อัปโหลด
              </p>
              <p style={{ fontSize: "12px" }} className="my-2">
                แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
              </p>
            </label>
            {/* <p className={item.file[0]?.name ? "" : "color-red"} style={{ lineHeight: 1.2 }}>
            {!item.file[0]?.name && (
              <p id={"showTextUplodas" + arrayId}>
                กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์
              </p>
            )}
            
          </p> */}
          </>
          )
          //    <Form.Item label={""} style={{ marginBottom: "0px" }} hidden>
          //   {this.props.propFormInput.getFieldDecorator(
          //     `attachFile[${arrayId}].file`,
          //     {
          //       initialValue: item.file ? item.file : null,
          //     }
          //   )(<Input />)}
          // </Form.Item>
        }

        {!item.attachFileId ? (
          item.file.length > 0 && (
            <Text
              onClick={() => {
                this.modalShowFileCreate(
                  dataTalbeUploads[arrayId].file[0],
                  "เอกสาร"
                );
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              {/* {fileNameShow} */}
              ดูไฟล์อัปโหลด
            </Text>
          )
        ) : (
          <Text
            onClick={() => {
              this.modalShowFileDataBase(item, "เอกสาร");
            }}
            style={{ cursor: "pointer" }}
            className="btn-show-fileuploads"
          >
            {/* {fileNameShow} */}
            ดูไฟล์เอกสารแนบ
          </Text>
        )}

        {!item.attachFileId ? (
          <Form.Item label={""} style={{ marginBottom: "0px" }}>
            {propFormInput.getFieldDecorator(`attachFile[${arrayId}].file`, {
              initialValue: [],
              // valuePropName: 'fileList',
              valuePropName: "fileList",
              getValueFromEvent: (e) => this.normFile(e.target.files, arrayId),
              rules: [
                {
                  required: true,
                  message: "กรุณาแนบไฟล์",
                },
              ],
            })(
              <input
                // id={"input-file-"+arrayId}
                className="input-file"
                // multiple
                type="file"
                // accept="file_extension"
                onChange={(e) => this.handleAdd(e.target.files, arrayId)}
                accept="image/png, image/jpeg, application/pdf"
                style={{ height: "0px" }}
              />
            )}
          </Form.Item>
        ) : (
          ""
        )}
      </>
    );
  };

  handleAdd = async (images, arrayId) => {
    const { propFormInput } = this.props;
    const fields = propFormInput.getFieldsValue();
    const { attachFile } = fields;
    const { dataTalbeUploads } = this.state;
    if (images) {
      if (
        images[0].type == "image/jpeg" ||
        images[0].type == "application/pdf" ||
        images[0].type == "image/png"
      ) {
      let item = { ...attachFile[arrayId] };

      console.log("xczzxczczitem", item);
      let dataSourceitems = [...this.state.dataTalbeUploads];
      dataSourceitems[arrayId] = item;

      await this.setState(
        {
          dataTalbeUploads: dataSourceitems,
        },
        () => {
          // this.cllBackSetValueOrganizatuions()
        }
      );
    }
    // else{
    //   Modal.error({
    //     className: "modalFickIcons",
    //     title:
    //       "อัปโหลดไฟล์ไม่สำเร็จ",
    //     width: "600px",
    //     content: <h3 className="mt-3">กรุณาอัปโหลดไฟล์สกุล .jpg .png หรือ .pdf</h3>,
    //     okText: "ปิด",
    //     onOk() {},
    //   });
    // }
  }
    
  };

  normFile = (images, arrayId) => {
    const { propFormInput } = this.props;
    const fields = propFormInput.getFieldsValue();
    const { attachFile } = fields;
    let item = { ...attachFile[arrayId] };
    if (images) {
      console.log("images outside",images)
      if (
        images[0].type == "image/jpeg" ||
        images[0].type == "application/pdf" ||
        images[0].type == "image/png"
      ) {
        console.log("images inside",images)
    item.file[0] = images[0];
      }
    }
    // return item.file;
    return item.file;
  };

  destroyArrayDataUploads = async (arrayId, dataRecord) => {
    const { propFormInput } = this.props;
    //  const fields = propFormInput.getFieldValue("attachFile");
    //  const { attachFile } = fields;
    let attachFile = propFormInput.getFieldValue("attachFile");
    var arrayDataSource = [...this.state.dataTalbeUploads];
    arrayDataSource.splice(arrayId, 1);

    if (dataRecord?.attachFileId) {
      console.log("delete datarecord", dataRecord);
      let deleteAbstain = propFormInput.getFieldValue("arrayFileDelete");
      let deleteFile = [...deleteAbstain, dataRecord.attachFileId];
      propFormInput.setFieldsValue({
        arrayFileDelete: deleteFile,
      });
    }

    console.log("arrayDataSource", arrayDataSource);

    await this.setState(
      {
        dataTalbeUploads: arrayDataSource,
        // dataTalbeLength: lengthData
      },
      async () => {
        await arrayDataSource.map(async (valuesTable, keysTable) => {
          console.log("attachFile getfield", attachFile);

          // if (valuesTable[keysTable+1]?.attachFileId) {
          //    console.log('valuesTable[keysTable+1]', valuesTable[keysTable+1])
          console.log("valuesTable arrayDataSource id", valuesTable);

          if (valuesTable.attachFileId) {
            await Object.assign(attachFile[keysTable], {
              attachFileId: valuesTable.attachFileId,
              documentType: valuesTable.documentType,
              description: valuesTable.description,
              filePath: valuesTable.filePath,
            });
          } else {
            await Object.assign(attachFile[keysTable], {
              documentType: valuesTable.documentType,
              description: valuesTable.description,
              file: valuesTable.file,
            });
          }

          // }
          // else {
          //     await Object.assign(attachFile[keysTable],
          //    {
          //       documentType: valuesTable.documentType,
          //       description: valuesTable.description,
          //       file: valuesTable.file,
          //    }
          // )
          // }
          console.log("attachFile after", attachFile);
          await propFormInput.setFieldsValue({ attachFile });
          console.log(
            "get attachFile after",
            propFormInput.getFieldValue("attachFile")
          );
        });
      }
    );
  };

  showDetailBtnInput = (record, arrayId) => {
    const { isViewOnly } = this.props;

    return (
      <>
        <Avatar
          shape="square"
          icon={<Icon type="delete" />}
          className="mr-1 mb-1 bg-red"
          onClick={() =>
            !isViewOnly ? this.destroyArrayDataUploads(arrayId, record) : ""
          }
          style={{
            cursor: !isViewOnly ? "pointer" : "no-drop",
            background: !isViewOnly ? "red" : "#9d9d9d",
          }}
        />
      </>
    );
  };

  showDataInputUploads = async () => {
    const { dataTalbeUploads, reqAttachDayStatus } = this.state;
    const { formRef } = this.props;

    const rows = {
      documentType: null,
      description: null,
      file: [],
    };

    await this.setState(
      (prevState) => ({
        dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        inputNumberOnBlur: true,
      }),
      async () => {
        let lengthData = dataTalbeUploads.length + 1;
        await this.setState({
          dataTalbeLength: lengthData,
        });
        //    const fields = formRef.current.getFieldsValue()
        //    const { StudyLeavePaymentsDetail } = fields

        // await Object.assign(StudyLeavePaymentsDetail[dataTalbeUploads.length],
        //    {
        //       studyFeeDetailBookNo: '',
        //       studyFeeDetailInvoiceNo: '',
        //       studyFeeDetailInvoiceDate: null,
        //       studyFeeDetailPrice: "0.00",
        //       studyFeeDetailActualPrice: "0.00",
        //       studyFeeAttachments: [],
        //       studyFeeDetailType: "INVOICE",
        //    }
        // )

        // await formRef.current.setFieldsValue({ StudyLeavePaymentsDetail })

        // await this.setState({
        //    dataTalbeUploads: StudyLeavePaymentsDetail,
        // });
      }
    );
  };

  async componentDidMount() {
    const { rawData } = this.props;
    // await this.dropdownLeaveType()

    if (rawData) {
      let rawDataNew = [];
      await rawData.map(async (valuesTable, keysTable) => {
         console.log("valuesTable.attachFileId",valuesTable.attachFileId)
        //rawDataNew[keysTable].push(valuesTable.attachFileId);
        //rawDataNew[keysTable].push(valuesTable.fileType);
     // rawDataNew[keysTable].attachFileId = valuesTable.attachFileId
      //   rawDataNew[keysTable].fileType = valuesTable.fileType
       rawDataNew[keysTable] = {
         attachFileId : valuesTable.attachFileId,
         fileType : valuesTable.fileType,
         filePath : valuesTable.filePath,
         description : valuesTable.description,
         documentType : valuesTable.documentType,
     } ;
      });

      console.log("rawDataNew",rawDataNew)
      await this.setState({
        dataTalbeUploads: rawDataNew,
      });
    }
  }

  render() {
    const { match, loginProfile, propFormInput, isViewOnly, rawData } =
      this.props;
    const { columnsAttachment, dataTalbeUploads } = this.state;
    console.log("rawDxxxxata", rawData);

    console.log("dataTalbeUploads attach", dataTalbeUploads);
    return (
      <div className="box-color-white">
        <Row gutter={16} type="flex" justify="left" align="top">
          <Col xs={24} md={24} className="">
            <strong className="color-red">เอกสารแนบ :</strong>
          </Col>
        </Row>
        <Row gutter={16} type="flex" justify="left" align="top">
          <Col xs={24} md={24} align={"right"} className="pt-4">
            <Table
              columns={columnsAttachment}
              dataSource={dataTalbeUploads}
              className="mb-3"
              bordered
              //rowCount={dataTalbeUploads.length}
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              pagination={false}
            />
            {isViewOnly == false && (
              <Button
                style={{ display: "inline-block" }}
                type="primary btn-color-default btn-custom btn-clear color-white"
                className="mt-1 mr-2"
                onClick={() => this.showDataInputUploads()}
              >
                เพิ่มเอกสารแนบ +
              </Button>
            )}
            <Form.Item style={{ marginBottom: "0px" }} hidden>
              {this.props.propFormInput.getFieldDecorator(`arrayFileDelete`, {
                initialValue: [],
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SecProfileInformation;
